var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.upcoming && _vm.upcoming.length) || (_vm.current && _vm.current.length))?_c('div',{staticClass:"bootcamp-results__upcoming"},[_c('h3',{staticClass:"bootcamp-results__title"},[_vm._v("\n    Upcoming Bootcamps\n  ")]),_c('div',{staticClass:"bootcamp-results__upcoming-body"},[_vm._l((_vm.current),function(item){return _c('div',{key:item.objectID,staticClass:"bootcamp-results__item"},[_c('BootcampTile',_vm._b({on:{"element-rend":_vm.handleRememberPosition}},'BootcampTile',{
          bootcamp: item,
          formatDateForBootcamp: _vm.formatDateForBootcamp,
          renderMarkdown: _vm.renderMarkdown,
          epoch: true,
          current: true,
        },false))],1)}),_vm._l((_vm.upcoming),function(item){return _c('div',{key:item.objectID,staticClass:"bootcamp-results__item"},[_c('BootcampTile',_vm._b({on:{"element-rend":_vm.handleRememberPosition}},'BootcampTile',{
          bootcamp: item,
          formatDateForBootcamp: _vm.formatDateForBootcamp,
          renderMarkdown: _vm.renderMarkdown,
          epoch: true,
          isNext: item.start_datetime === _vm.nextBootcampDate,
        },false))],1)})],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }